import React from 'react';
import "./style.css"
const Education = () => {
    return (
        <>
        <section>
            <h2 className='text-secondary text-5xl ml-8F '>Education & Experience</h2>
        <div class="bg-accent text-white pb-5">
        <div class="container mx-auto flex flex-col items-start md:flex-row my-12 md:my-24">
          <div class="flex flex-col w-full sticky md:top-36 lg:w-1/3 mt-2 md:mt-12 px-8"   data-aos-duration="3500"
        data-aos-easing="ease-in-out"
        data-aos="fade-right">
            <p class="ml-2 text-primary uppercase tracking-loose">Working Process</p>
            <p class="text-3xl md:text-4xl leading-normal md:leading-relaxed mb-2 text-secondary">About Me</p>
            <p class="text-sm md:text-base text-secondary mb-4 text-secondary">
            As a passionate Full Stack Developer and Data Scientist, I am dedicated to creating innovative solutions that push the boundaries of technology. With a strong foundation in both front-end and back-end development, I bring a unique blend of skills that empower me to build robust and user-centric applications.
            </p>
            
          </div>
          <div class="ml-0 md:ml-12 lg:w-2/3 sticky"   data-aos-duration="6500"
        data-aos-easing="ease-in-out"
        data-aos="zoom-in">
            <div class="container mx-auto w-full h-full">
              <div class="relative wrap overflow-hidden p-10 h-full">
                <div class="border-2-2 border-yellow-555 absolute h-full border thumb-education"
                style={{right:'50%',border: '2px solid ', borderRadius: '1%'}}
                 ></div>
                <div class="border-2-2 border-yellow-555 absolute h-full border thumb-education"
                style={{left:'50%',border: '2px solid ', borderRadius: '1%'}}></div>
                <div class="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div class="order-1 w-5/12"></div>
                  <div class="order-1 w-5/12 px-1 py-4 text-right">
                  
                    <h4 class="mb-3 font-bold text-lg md:text-2xl text-primary">MERN Stack Web Developer</h4>
                    <p class="text-sm md:text-base leading-snug text-secondary text-opacity-100">
                    <p class="mb-3 text-base text-primary"> Programming Hero | Nov 1 - Nov 9, 2018</p>
Through unwavering dedication and relentless hard work, I honed my skills to become a proficient MERN Stack Web Developer under the guidance of Programming Hero. This experience instilled in me the importance of continuous learning and staying ahead in the dynamic tech landscape.
                    </p>
                  </div>
                </div>
                <div class="mb-8 flex justify-between items-center w-full right-timeline">
                  <div class="order-1 w-5/12"></div>
                  <div class="order-1  w-5/12 px-1 py-4 text-left">
                    <p class="mb-3 text-base text-primary">6-9 May, 2018</p>
                    <h4 class="mb-3 font-bold text-lg md:text-2xl text-primary">UI/UX DESIGNER </h4>
                    <p class="text-sm md:text-base leading-snug text-secondary text-opacity-100">
                    Armed with a creative mindset and strong problem-solving skills, I ventured into the realm of UI/UX design. My journey equipped me with an innate ability to think outside the box and create visually captivating interfaces that resonate with users. I stay current with the latest trends and technologies, ensuring that my designs are always cutting-edge.
                    </p>
                  </div>
                </div>
                <div class="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div class="order-1 w-5/12"></div>
                  <div class="order-1 w-5/12 px-1 py-4 text-right">
                    <p class="mb-3 text-base text-primary"> 10 Jun, 2017</p>
                    <h4 class="mb-3 font-bold text-lg md:text-2xl text-primary">CONSULTANT</h4>
                    <p class="text-sm md:text-base leading-snug text-secondary text-opacity-100">
                    My role as a consultant allowed me to collaborate closely with clients and stakeholders, shaping the digital experiences that leave a lasting impact. From designing user-friendly interfaces to seamlessly integrating data, applications, and media elements, I have a proven track record of delivering exceptional websites. My attention to detail and commitment to incorporating user feedback ensure that every project exceeds expectations.
                    </p>
                  </div>
                </div>
    
                <div class="mb-8 flex justify-between items-center w-full right-timeline">
                  <div class="order-1 w-5/12"></div>
    
                  <div class="order-1  w-5/12 px-1 py-4">
                    <p class="mb-3 text-base text-primary">Computer Science Engineering - Programming-Hero | Phitron | Feb 12, 2021</p>
                    <h4 class="mb-3 font-bold  text-lg md:text-2xl text-left text-primary">BACHELOR DEGREE</h4>
                    <p class="text-sm md:text-base leading-snug text-secondary text-opacity-100">
                    My educational journey laid the foundation for my technical prowess. With a Bachelor's degree in Computer Science and Engineering from Programming-Hero Phitron, I gained a comprehensive understanding of the core principles that underpin cutting-edge technology.
                    </p>
                  </div>
                </div>
              </div>
              <img class="mx-auto -mt-36 md:-mt-36" src="https://user-images.githubusercontent.com/54521023/116968861-ef21a000-acd2-11eb-95ac-a34b5b490265.png" />
            </div>
          </div>
        </div>
      </div>
      </section>
        </>
    );
};

export default Education;